/****
let algolia = window.algoliaShopify;

document.addEventListener("algolia.hooks.initialize", function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter)  {
    const partner = window.BARREL.partner;

    if (defaultFilter) {
      return  defaultFilter + ' AND meta.Algolia.Partners:' + partner;
    }
    else {
      return 'meta.Algolia.Partners:' + partner;
    }
  });
});
****/

document.addEventListener("algolia.hooks.initialize", function () {
  let algoliaShopify = window.algoliaShopify;
  // Replace 'myCookie' with the actual cookie name
  const rawCookieValue = getCookieValue("OptanonConsent");
  if (rawCookieValue) {
    // 2. Extract the 'groups' value from the cookie string
    const params = new URLSearchParams(rawCookieValue);
    const groups = params.get("groups"); // e.g., "1:1,2:1,3:1,4:1,5:1"

    if (groups) {
      // 3. Parse the 'groups' string into key-value pairs
      const groupObj = {};
      groups.split(",").forEach((pair) => {
        const [key, value] = pair.split(":");
        groupObj[key] = value;
      });

      // 4. Get the value for key "2"
      const valueOf2 = groupObj["2"];
      if (valueOf2 == 0) {
        algoliaShopify.hooks.registerHook(
          "beforeInstantSearchConfigurationOptions",
          function (options) {
            options.insights = false;
            return options;
          }
        );
        algoliaShopify.hooks.registerHook(
          "beforeAlgoliaAnalyticsOptions",
          function (options) {
            options.userHasOptedOut = true;
            options.useCookie = false;
            return options;
          }
        );
      }
      if (valueOf2 == 1) {
        algoliaShopify.hooks.registerHook(
          "beforeInstantSearchConfigurationOptions",
          function (options) {
            options.insights = true;
            return options;
          }
        );
        algoliaShopify.hooks.registerHook(
          "beforeAlgoliaAnalyticsOptions",
          function (options) {
            options.userHasOptedOut = false;
            options.useCookie = true;
            return options;
          }
        );
      }
    } else {
      // console.log("No 'groups' key found in cookie.");

      algoliaShopify.hooks.registerHook(
        "beforeInstantSearchConfigurationOptions",
        function (options) {
          options.insights = false;
          return options;
        }
      );
      algoliaShopify.hooks.registerHook(
        "beforeAlgoliaAnalyticsOptions",
        function (options) {
          options.userHasOptedOut = true;
          options.useCookie = false;
          return options;
        }
      );
    }
  } else {
    // console.log("Cookie not found.");

    algoliaShopify.hooks.registerHook(
      "beforeInstantSearchConfigurationOptions",
      function (options) {
        options.insights = false;
        return options;
      }
    );
    algoliaShopify.hooks.registerHook(
      "beforeAlgoliaAnalyticsOptions",
      function (options) {
        options.userHasOptedOut = true;
        options.useCookie = false;
        return options;
      }
    );
  }

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteNoResultsTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;

      if (state.query === "") return;
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="TermsLayout">${window.BARREL.algoliaTermsText}</div>
          <p class="aa-NoResultsHeader">
            No results were found. Try searching for something else.
          </p>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainTemplate",
    function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html } = templateOptions;
      // Don't return the default template and return a custom two-column layout instead
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="TermsLayout">${window.BARREL.algoliaTermsText}</div>
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left">
              ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"
                    >${algoliaShopify.translations.suggestions}</span
                  >
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
              ${elements.collections} ${elements.articles} ${elements.pages}
              ${elements.redirectUrlPlugin}
            </div>
            <div class="aa-PanelSection--right">${elements.products}</div>
          </div>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainProductsTemplate",
    function (_defaultTemplate, templateOptions, elements) {
      const { html } = templateOptions;
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="TermsLayout">${window.BARREL.algoliaTermsText}</div>
          <div class="aa-PanelSection">${elements.products}</div>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteFiltersString",
    function (defaultFilter) {
      const partner = window.BARREL.partner;
      // console.log("beforeAutocompleteFiltersString", { partner });

      if (defaultFilter) {
        return defaultFilter + " AND meta.Algolia.Partners:" + partner;
      } else {
        return "meta.Algolia.Partners:" + partner;
      }
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFiltersString",
    function (defaultFilter) {
      const partner = window.BARREL.partner;
      // console.log("beforeInstantSearchFiltersString", { partner });

      if (defaultFilter) {
        return defaultFilter + " AND meta.Algolia.Partners:" + partner;
      } else {
        return "meta.Algolia.Partners:" + partner;
      }
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFiltersString",
    function (defaultFilter) {
      if (defaultFilter && defaultFilter.includes("collection_ids")) {
        const collectionIDFilterRegex = /collection_ids:"\w+"/g;
        const matches = window.location.pathname.match(
          /\/collections\/([^/]+)/i
        );
        const collectionHandle =
          matches && matches.length === 2 ? matches[1] : null;
        if (collectionHandle) {
          return defaultFilter.replace(
            collectionIDFilterRegex,
            "collections:" + collectionHandle
          );
        }
      }
      return defaultFilter;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchMainTemplate",
    function (_defaultTemplate, data, html) {
      return html`
        <div class="ais-page">
          <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">Show filters</div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              (facet) =>
                html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                  >
                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                    />
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                  </div>
                `
            )}
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div class="ais-stats-container"></div>
              <div class="ais-change-display">
                <span
                  class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      ${algoliaShopify.translations.sortBy}
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html`
                      ${algoliaShopify.translations.sortBy}
                      ${algoliaShopify.translations.relevance}
                    `}
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components) {
      try {
        // return html`
        // <p>
        //   <div>
        //     ${hit.product_image}
        //   </div>
        //   <div>
        //     ${hit.vendor}
        //   </div>
        //   <div>
        //     ${hit.title}
        //   </div>
        //   <div>
        //     ${hit.sku}
        //   </div>
        //   <div>
        //     ${hit.price}
        //   </div>
        // </p>
        // `
        const MOQ_tag = hit.tags.find((s) => s.includes("MOQ_"));
        let MOQ = 0;
        if (MOQ_tag) {
          MOQ = Number(MOQ_tag.split("_")[1] || 0);
        }
        let ctaButton;
        if (hit.can_order && hit.inventory_quantity > 12) {
          ctaButton = html`
            <button
              class="ais-hit--cart-button"
              data-quantity="${MOQ > 1 ? MOQ : 1}"
              data-form-id="algolia-add-to-cart-${hit.objectID}"
            >
              ${algoliaShopify.translations.addToCart}
            </button>
          `;
        }
        return html`
          <div
            href="${algoliaShopify.helpers.instantsearchLink(hit)}"
            class="ais-hit ais-product override js-product-card"
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            data-handle="${hit.handle}"
            data-variant-id="${hit.objectID}"
            data-distinct="${hit._distinct}"
            data-product-id="${hit.id}"
            data-qty="${MOQ || 1}"
            data-product-json="${hit ? JSON.stringify(hit) : ""}"
            data-available="${hit.inventory_quantity <= 12
              ? false
              : hit.can_order}"
          >
            <div class="ais-hit--wishlist" data-heart-filled="false">
              <span class="wishlist__heart-full" data-fill="false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.647 2.2788C11.342 2.2788 10.0895 2.8863 9.27197 3.8463C8.45447 2.8863 7.20197 2.2788 5.89697 2.2788C3.58697 2.2788 1.77197 4.0938 1.77197 6.4038C1.77197 9.2388 4.32197 11.5488 8.18447 15.0588L9.27197 16.0413L10.3595 15.0513C14.222 11.5488 16.772 9.2388 16.772 6.4038C16.772 4.0938 14.957 2.2788 12.647 2.2788Z"
                    fill="#000"
                  />
                </svg>
              </span>
              <span class="wishlist__heart-empty ">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.77197 3.81749C10.5895 2.85749 11.842 2.24999 13.147 2.24999C15.457 2.24999 17.272 4.06499 17.272 6.37499C17.272 9.20767 14.7262 11.5162 10.869 15.0139L10.8595 15.0225L9.77197 16.0125L8.68447 15.03L8.65486 15.0031C4.80895 11.5082 2.27197 9.20274 2.27197 6.37499C2.27197 4.06499 4.08697 2.24999 6.39697 2.24999C7.70197 2.24999 8.95447 2.85749 9.77197 3.81749ZM9.77198 13.9875L9.84698 13.9125C13.417 10.68 15.772 8.54253 15.772 6.37503C15.772 4.87503 14.647 3.75003 13.147 3.75003C11.992 3.75003 10.867 4.49253 10.477 5.52003H9.07448C8.67698 4.49253 7.55198 3.75003 6.39698 3.75003C4.89698 3.75003 3.77198 4.87503 3.77198 6.37503C3.77198 8.54253 6.12698 10.68 9.69698 13.9125L9.77198 13.9875Z"
                    fill="#BDBDBD"
                  />
                </svg>
              </span>
            </div>
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.largeImage(hit)}"
              alt="${hit.title} - ${hit.variant_title}"
            />

            <div class="ais-hit--details">
              <p class="ais-hit--vendor">
                ${hit.tags && hit.tags.length > 0 && ProductBadges(hit, html)}
              </p>
              <div
                class="product-card__badges empty:hidden mt-2 mb-1 flex flex-wrap h-[25px] lg:h-[27px]"
              >
                <div class="flex items-center">
                  <span
                    class="badge mr-1 mb-1 p-1 p2 font-bold product-card__badge bg-yellow text-black"
                    >${hit.vendor}</span
                  >
                </div>
              </div>
              <p class="ais-hit--sku">${hit.sku}</p>
              <p class="ais-hit--title override">
                <a
                  data-algolia-index="${hit.index}"
                  data-algolia-position="${hit.productPosition}"
                  data-algolia-queryid="${hit.queryID}"
                  data-algolia-objectid="${hit.objectID}"
                  href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                  onclick="void(0)"
                  title="${algoliaShopify.helpers.fullTitle(
                    hit.title,
                    hit._distinct,
                    hit.variant_title
                  )}"
                >
                  ${components.Highlight({ attribute: "title", hit })}
                  ${algoliaShopify.helpers.variantTitleAddition(
                    hit,
                    hit._distinct
                  )}
                </a>
              </p>
              <p
                class="ais-hit--subtitle"
                title="${hit.sku}${algoliaShopify.translation_helpers.by(
                  hit.vendor
                )}"
              >
                ${components.Highlight({ attribute: "vendor", hit })}
              </p>
              <p class="ais-hit--price">
                ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
                ${!hit._distinct &&
                html`
                  <span class="ais-hit--price-striked"
                    ><span
                      >${algoliaShopify.helpers.displayStrikedPrice(
                        hit.price,
                        hit.compare_at_price
                      )}</span
                    ></span
                  >
                `}
              </p>
              <p class="ais-hit--moq">
                ${MOQ > 1 ? html`Must buy in multiples of ${MOQ}` : html``}
              </p>
              ${!hit._distinct &&
              html`
                ${hit.can_order && hit.inventory_quantity > 12
                  ? html`
                      <p class="ais-hit--cart js-cta-button">
                        ${html`${ctaButton}`}
                      </p>
                    `
                  : html`
                      <p class="ais-hit--cart">
                        <button
                          type="button"
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      </p>
                    `}
              `}
            </div>
          </div>
        `;
      } catch (e) {
        console.log("Alogila error", e);
      }
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      const { html, item, components } = templateOptions;
      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
        >
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${algoliaShopify.helpers.compactImage(item)}"
                alt="${item.title}"
              />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">
                ${item.product_type &&
                components.Highlight({ hit: item, attribute: "product_type" })}
              </div>
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                  <span class="algolia-variant">
                    ${algoliaShopify.helpers.variantTitleAddition(
                      item,
                      distinct
                    )}
                  </span>
                </div>
              </div>
              <!-- Add SKU here -->
              <div class="aa-ItemContentSKU">${item.sku}</div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                  ${algoliaShopify.helpers.displayPrice(item, distinct)}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );
});

// function toggleWishlist(productCard) {
//   let wishlist = productCard.querySelector(".ais-hit--wishlist");
//   if (wishlist.dataset.heartFilled !== "true") {
//     wishlist.querySelector(".wishlist__heart-full").style.display = "block";
//     wishlist.querySelector(".wishlist__heart-empty").style.display = "none";
//     wishlist.setAttribute("data-heart-filled", true);
//   } else {
//     wishlist.querySelector(".wishlist__heart-full").style.display = "none";
//     wishlist.querySelector(".wishlist__heart-empty").style.display = "block";
//     wishlist.setAttribute("data-heart-filled", false);
//   }
// }

// async function makeRequest(path, method, payload = null) {
//   try {
//     const endpoint = window.BARREL.sbdApiUrl;
//     const token = window.BARREL.sbdApiAccessToken;
//     const url = `${endpoint}/${path}`;

//     const reqConfig = {
//       method,
//       headers: {
//         token,
//         mode: "no-cors",
//       },
//     };
//     if (payload) {
//       reqConfig.headers["Content-Type"] = "application/json";
//       reqConfig.body = JSON.stringify(payload);
//     }
//     const response = await fetch(url, reqConfig);
//     if (!response.ok) {
//       throw new Error(`${response.status} - ${response.statusText}`);
//     }
//     const data = await response.json();

//     return data;
//   } catch (error) {
//     console.error(`Error makeRequest: ${method} - ${error}`);
//   }
// }

// async function handleChangeWishlist(event) {
//   event.stopPropagation();
//   const customerId = window.BARREL.customerId;
//   // console.log('wish click', event.target.closest('.ais-product'));
//   let productCard = event.target.closest(".ais-product");

//   if (productCard.dataset.wishlistId) {
//     const result = await makeRequest("removeWishListItem", "POST", {
//       customerId,
//       wishListItemId: productCard.dataset.wishlistId,
//     });
//     if (result) {
//       toggleWishlist(productCard);
//       productCard.removeAttribute("data-wishlist-id");
//     }
//   } else {
//     const result = await makeRequest("addWishListItem", "POST", {
//       customerId,
//       productId: productCard.dataset.productId,
//       handle: productCard.dataset.handle,
//       variantId: productCard.dataset.variantId,
//       qty: productCard.dataset.qty,
//       // title: productCard.dataset.title,
//     });
//     if (result) {
//       toggleWishlist(productCard);
//       productCard.setAttribute("data-wishlist-id", result.data.wishListItemId);
//     }
//   }
// }

// async function loadWishlistItems() {
//   try {
//     const customerId = window.BARREL.customerId;
//     const pageSize = 1000;

//     const response = await makeRequest(
//       `wishlist/list/${customerId}?pageSize=${pageSize}`,
//       "GET"
//     );
//     if (response) {
//       const wishlistItems = response.data;
//       for (let i = 0; i < wishlistItems.length; i++) {
//         const { wishListItemID, productID } = wishlistItems[i];
//         const productCard = document.querySelector(
//           `[data-product-id="${productID}"]`
//         );
//         if (productCard) {
//           productCard.setAttribute("data-wishlist-id", wishListItemID);
//           // toggleWishlist(productCard);
//           let wishlist = productCard.querySelector(".ais-hit--wishlist");

//           wishlist.querySelector(".wishlist__heart-full").style.display =
//             "block";
//           wishlist.querySelector(".wishlist__heart-empty").style.display =
//             "none";
//           wishlist.setAttribute("data-heart-filled", true);
//         }
//       }
//     }
//   } catch (error) {
//     console.error("Error loadWishlistItems: ", error.message);
//   }
// }

//document.addEventListener("algolia.instantSearch.onRender", async () => {
// let wishlistItems = document.querySelectorAll(".ais-hit--wishlist");
// if (wishlistItems.length) {
//   await loadWishlistItems();
//   wishlistItems.forEach((ele) => {
//     ele.addEventListener("click", handleChangeWishlist);
//   });
// }
//});

function getCookieValue(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return null;
}

document.addEventListener("algolia.instantSearch.onRender", async (e) => {
  // console.log("onrender", e);
  let productCards = document.querySelectorAll(".js-product-card");
  await loadCTAButton(productCards);
});

async function loadCTAButton(productCards) {
  for (let i = 0; i < productCards.length; i++) {
    const item = productCards[i];
    // console.log("item", item);
    const productData = item.dataset?.productJson
      ? JSON.parse(item.dataset.productJson)
      : {};
    let { can_order: available, id: productId, tags } = productData;

    let parent = item.querySelector(".js-cta-button");

    const { variants } = await fetchProductDetails(productId);
    productData["variants"] = variants;
    const MOQ_tag = productData.tags.find((s) => s.includes("MOQ_"));
    let MOQ = 1;
    if (MOQ_tag) {
      MOQ = Number(MOQ_tag.split("_")[1] || 1);
    }

    productData["quantity"] = MOQ;

    if (available) {
      let newChild = document.createElement("button");
      newChild.className = "ais-hit--cart-button";
      newChild.textContent = "Add to Cart";
      newChild.type = "button";
      newChild.addEventListener("click", (event) => {
        trackProductClick(productData);
        addToCart(event, productData);
      });
      parent.replaceChild(newChild, parent.firstChild);
    }
  }
}

const fetchProductDetails = async (id) => {
  try {
    const res = await storefrontClient(`query {
    product(id: "gid://shopify/Product/${id}") {
      variants(first: 10){
        nodes{
            id
            availableForSale
        }
      }
    }
  }`);

    return {
      variants: res.data?.product?.variants?.nodes || [],
    };
  } catch (err) {
    console.error("error", err);
  }
};

function storefrontClient(query, variables, version) {
  version = version || "2022-07";

  const endpoint = `https://${window.BARREL.shop}/api/${version}/graphql.json`;
  const method = "POST";
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Shopify-Storefront-Access-Token": window.BARREL.storefrontAccessToken,
  };

  return fetch(endpoint, {
    method: method,
    headers: headers,
    body: JSON.stringify({
      query: query,
      ...(variables && { variables }),
    }),
  }).then((response) => response.json());
}

const addToCart = async (event, productData) => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const variantAvailable = productData.variants.find(
    (variant) => variant.availableForSale
  );

  const variantId = variantAvailable
    ? variantAvailable.id.replace("gid://shopify/ProductVariant/", "")
    : productData.objectID;

  const formData = {
    items: [
      {
        id: variantId,
        quantity: productData.quantity,
      },
    ],
    sections: "site-header,cart",
    sections_url: window.location.pathname,
  };
  await document.querySelector("shopify-cart").addItem(formData);
 
};

function ProductBadges(hit, html) {
  let { tags, price, compare_at_price: comparePrice } = hit;
  const availableForSale = true;
  const isBundle = false;

  const handleize = (string) =>
    string
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-$/, "")
      .replace(/^-/, "");

  if (!tags || !tags.length) return "";

  let badges = [];
  const max = 2;

  if (comparePrice > price) {
    badges.push("Sale");
  }

  const labelClass =
    "mr-1 mb-1 p-1 p2 font-bold product-card__badge bg-blue text-white";

  const sortRules =
    "badge:Best Seller,badge:NEW PRODUCT,badge:GIFT IDEA,badge:On Sale,badge:Sale,badge:RECENTLY ADDED,badge:,badge_custom1:,badge_custom2:,badge_custom:";
  const sortRulesArr = sortRules.split(",");

  sortRulesArr.forEach((rule) => {
    if (rule === "badge:") {
      const listBadge = tags.filter(
        (tag) =>
          !sortRulesArr.includes(tag) &&
          tag.startsWith("badge:") &&
          !tag.startsWith("badge_custom")
      );
      if (listBadge.length) {
        badges = badges.concat(
          listBadge.map((tag) => tag.replace("badge:", ""))
        );
      }
    }

    if (rule === "badge_custom:") {
      const listBadgeCustom = tags.filter((tag) =>
        /^badge_custom[0-9]*:/.test(tag)
      );
      if (listBadgeCustom.length) {
        badges = badges.concat(listBadgeCustom);
      }
    }

    if (tags.includes(rule)) {
      badges.push(rule.replace("badge:", ""));
    }
  });

  const customBadges = badges.filter((b) => /^badge_custom[0-9]*:/.test(b));
  const regularBadges = badges.filter((b) => !/^badge_custom[0-9]*:/.test(b));

  let finalBadges = [...new Set([...regularBadges, ...customBadges])];

  finalBadges = finalBadges.slice(0, max);

  let hideSaleTag = false;
  if (tags.includes("available:online") && !tags.includes("D2C-Restriction")) {
    hideSaleTag = !(availableForSale || isBundle);
  } else {
    hideSaleTag = true;
  }

  if (hideSaleTag) {
    finalBadges = finalBadges.filter((e) => e !== "Sale");
  }

  if (!finalBadges.length) return "";

  return html`<div
    className="product-card__badges empty:hidden mt-2 mb-1 flex flex-wrap h-[25px] lg:h-[27px]"
  >
    ${finalBadges.map((tag) => {
      if (/^badge_custom[0-9]*:/.test(tag)) {
        const [key, value] = tag.split(":");
        const bgValue = `bg-${handleize(value)}`;
        const bgType = `bg-${key}`;
        return html`<div class="flex">
          <span class="badge ${labelClass} ${bgValue} ${bgType}">${value}</span>
        </div>`;
      }

      return html`<div class="flex">
        <span class="badge ${labelClass} bg-${handleize(tag)}">${tag}</span>
      </div>`;
    })}
  </div>`;
}

function handleize(string) {
  return string
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");
}

function trackProductClick(productData) {
  if (
    !productData ||
    !productData.objectID ||
    !productData.queryID ||
    !productData.index
  ) {
    console.warn("Missing product tracking info. Skipping Algolia click event.");
    return;
  }

  const clickedObject = {
    eventName: 'Product Clicked',
    index: productData.index,
    objectIDs: [productData.objectID],
    productId: productData.id,
    positions: [productData.productPosition || 1],
    queryID: productData.queryID,
  };

  try {
    // Update localStorage 
    const storageKey = 'algolia_analytics_clicked_objects';
    const existing = JSON.parse(localStorage.getItem(storageKey) || '[]');
    const updated = existing.filter(obj => obj.objectIDs[0] !== productData.objectID);
    updated.push(clickedObject);
    console.log("updated",updated)
    localStorage.setItem(storageKey, JSON.stringify(updated));


  } catch (err) {
    console.error("Failed to track product click:", err);
  }
}


document.addEventListener(  
  "click",
  function (e) {
    try {
      // Ignore Add-To-Cart buttons
      if (e.target.closest(".ais-hit--cart-button")) return;

      const productEl = e.target.closest(".ais-product");
      if (!productEl) return;

      const payload = {
        objectID: productEl.dataset.algoliaObjectid,
        queryID: productEl.dataset.algoliaQueryid,
        index: productEl.dataset.algoliaIndex,
        id: productEl.dataset.productId,
        productPosition: productEl.dataset.algoliaPosition
      };

      if (!payload.objectID || !payload.queryID || !payload.index) return;

      if (typeof window.trackProductClick === "function") {
        window.trackProductClick(payload);
      }
    } catch (err) {
      console.error("Delegated click tracking error:", err);
    }
  },
  true
);

window.trackProductClick = trackProductClick;